document.addEventListener( 'DOMContentLoaded', () => {

	const wrappers = document.querySelectorAll(
		'.wp-block-hydromax-choose-your-adventure'
	);

	wrappers.forEach( ( wrapper ) => {

		const preview = wrapper.querySelector(
			'.cya__desktop-media'
		);

		const items = wrapper.querySelectorAll(
			'.wp-block-hydromax-choose-your-adventure-item'
		);

		if ( ! preview || ! items.length ) {
			return;
		}

		let activeItem = null;
		let isTransitioning = false;

		const setPreview = ( item ) => {

			if (
				activeItem === item ||
				isTransitioning
			) {
				return;
			}

			const mediaWrapper = item.querySelector(
				'.cya__mobile-media'
			);

			if ( ! mediaWrapper ) {
				return;
			}

			const mediaElement = mediaWrapper.querySelector(
				'img, video'
			);

			if ( ! mediaElement ) {
				return;
			}

			isTransitioning = true;

			activeItem = item;

			items.forEach( ( el ) => {
				el.classList.remove( 'is-active' );
			});

			item.classList.add( 'is-active' );

			/**
			 * Fade out
			 */
			preview.classList.add( 'is-changing' );

			setTimeout( () => {

				preview.innerHTML = '';

				const clonedMedia =
					mediaElement.cloneNode( true );

				if (
					clonedMedia.tagName === 'VIDEO'
				) {

					clonedMedia.autoplay = false;
					clonedMedia.muted = false;
					clonedMedia.loop = false;
					clonedMedia.playsInline = false;
					clonedMedia.controls = true;

					clonedMedia.play().catch(
						() => {}
					);
				}

				preview.appendChild(
					clonedMedia
				);

				/**
				 * Fade in
				 */
				requestAnimationFrame( () => {

					preview.classList.remove(
						'is-changing'
					);

					isTransitioning = false;

				});

			}, 250 );
		};

		/**
		 * Initial load
		 */
		setPreview( items[0] );

		/**
		 * Hover events
		 */
		items.forEach( ( item ) => {

			item.addEventListener(
				'mouseenter',
				() => {
					setPreview( item );
				}
			);

		});

	});

});